// extracted by mini-css-extract-plugin
export default {"google-pay-button":"CG9rTu","googlePayButton":"EMB5UL","rect":"LJZyoR","pill":"cgI92_"};